/**
 * This file maps URL's fo the new app to state names of the old
 * angualr JS app.
 *
 * The audit service is looking for a stateName from the angular 1.x app
 * so we have to create a map here.
 *
 * Broadcast message service will also receive a state name in order to display
 * a message on the coorosponding page.
 */
export const stateNameMap = new Map([
  ['/contracts', 'mycontracts'],
  ['/documents', 'myDocs'],
  ['/login/password', 'AntiPhishing'],
  ['/logout', 'logout'],
  ['/landing', 'securedHome'],
  ['/pay/home', 'pay.home'],
  ['/deductible/home', 'deductible'],
  ['/tin/home', 'tin.home'],
  ['/viewform/tinforms', 'viewform.tinforms'],
  ['/davis', 'davisvision'],
  ['/needHelp', 'needHelp'],
  ['/siteMap', 'sitemap'],
  ['/claims/onlineClaims/savedSubmittedClaim', 'onlineClaims.savedSubmitted'],
  ['/contactus', 'contactUs'],
  ['/mop/tceFrame', 'mopHome'],
  ['/mop/startpage', 'mopStartPage'],
  //tce
  ['/sdtce/tceFrame', 'sdtceHome'],
  ['/sdtce/startpage', 'sdtceStartPage'],

  ['/billing/manageautopay', 'manageAutopay'],
  ['/billing/billhistory', 'billHistory'],
  ['/billing/home', 'billingHome'],
  ['/billing/paymenthistory', 'paymentHistory'],
  ['/billing/billDetails', 'billDetails'],
  ['/billing/retroactiveDetails', 'retroActiveDetails'],
  ['/billing/glossary', 'glossary'],
  ['/billing/managepaymentmethods', 'managePaymentMethods'],
  ['/billing/enableautopay', 'enableAutopay'],
  ['/billing/receiptInfo', 'receiptInformation'],
  ['/billing/makepayment/step1', 'managePaymentStep1'],
  ['/billing/makepayment/step2', 'managePaymentStep2'],
  ['/billing/makepayment/step3', 'managePaymentStep3'],
  ['/fad/search', 'fad.search'],
  ['/fadsd/search', 'fadsd.search'],
  ['/fadsdpcp/search', 'fadsdpcp.search'],
  ['/fadpcp/search', 'fadpcp.search'],
  ['/fadpcp/search/request', 'fadpcp.search.pcpselect'],
  ['/fadpcp/search/selectpcp', 'fadpcp.search.pcpconfirm'],
   ['/fadsdpcp/search/request', 'fadsdpcp.search.pcpselect'],
   ['/fadsdpcp/search/selectpcp', 'fadsdpcp.search.pcpconfirm'],
  ['/faddentalpcp/search', 'faddentalpcp.search'],
  ['/faddentalpcp/search/selectpcp', 'faddentalpcp.search.pcpconfirm'],
  ['/fadsddentalpcp/search', 'fadsddentalpcp.search'],
  ['/fadsddentalpcp/search/selectpcp', 'fadsddentalpcp.search.pcpconfirm'],
  ['/fad/searchcvs', 'fad.searchcvs'],
  ['/registration/home1', 'registration.provideinfo'],
  ['/registration/home2', 'registration.createaccount'],
  ['/registration/home3', 'registration.confirm'],
  ['/mfa', 'mfa.verifyPasscode.home'],
  ['/mfa/verifyPasscode', 'mfa.verifyPasscode'],
  ['/mfa/alternateVerification', 'mfa.alternateVerificatiion'],
  ['/mfa/securityQuestions', 'mfa.securityQuestions'],
  ['/mfa/idcardVerification', 'mfa.idcardVerification'],
  ['/whoscovered/home', 'whosCoveredHome'],
  ['/whoscovered/addMember/addDependents', 'addMember.addDependents'],
  ['/whoscovered/removemember', 'removeMember'],
  ['/whoscovered/addMember', 'addMember'],
  ['/addDependents', 'addMember.addDependent'],
  ['/selectPCP', 'addMember.selectPCP'],
  ['/whoscovered/removeRequestSubmit', 'removeDependantSubmit'],
  ['/enrollment/demographicUpdates/home', 'demographicUpdateHome'],
  ['/enrollment/demographicUpdates/memberUpdate', 'memberUpdate'],
  ['/benefits/home', 'benefits.home'],
  ['/benefits/vision', 'benefits.vision'],
  ['/benefits/dental', 'benefits.dental'],
  ['/benefits/homehcbo', 'benefits.hcbo'],
  ['/profile/policyHolder/changeAddress', 'myProfileHome.changeAddress'],
  ['/profile/policyHolder/changePhone', 'myProfileHome.changeContactPhoneNumber'],
  ['/profile/policyHolder/raceEthnicityLanguage', 'myProfileHome.relicc'],
  ['/profile/securityInfo/changeImage', 'changeImage'],
  ['/profile/communicationpreference/newEmail', 'profile.newEmail'],
  ['/profile/securityInfo/securityQuestions', 'profile.securityQuestions'],
  ['/profile/securityInfo/securityQuestions', 'changeSecQuestPublic'],
  ['/profile/securityInfo/changePassword', 'profile.changePassword'],
  ['/profile/securityInfo/changePassword', 'oldPassword'],
  ['/accountRecovery/changePassword', 'changePassword'],
  ['/profile/communicationpreference/editMobilePhoneNumber', 'myProfileHome.changeTextPhoneNumber'],
  ['/profile/communicationpreference/confirmPhone', 'myProfileHome.confirmTextPhoneNumber'],
  ['/emailTextPromo/home', 'accountRecovery.home'],
  ['/emailTextPromo/editMobilePhoneNumber', 'accountRecovery.editMobilePhoneNumber'],
  ['/emailTextPromo/editEmailAddresss', 'accountRecovery.editEmailAddress'],
  ['/emailTextPromo/addMobilePhoneNumber', 'accountRecovery.addMobilePhoneNumber'],
  ['/emailTextPromo/confirmPhone', 'accountRecovery.confirmPhone'],
  ['/profile/personalInfo', 'myProfileHome'],
  ['/profile/communicationpreference/electroniccommunication', 'changeE-ComConsent'],
  ['/profile/policyHolder', 'myProfileHome'],
  ['/profile/communicationpreference', 'myProfileHome'],
  ['/profile/securityInfo', 'myProfileHome'],
  ['/cob/home', 'cob.coverage'],
  ['/cob/update', 'cob.update'],
  ['/cob/medicare', 'cob.toggleMedicare'],
  ['/cob/otherInfo', 'cob.otherInfo'],
  ['/cob/confirmUpdate', 'cob.confirm'],
  ['/cob/submitUpdate', 'cob.submit'],
  ['/fadcvsminuteclinic/search', 'fadcvsminuteclinic.search'],
  ['/benefits/result', 'benefits.result'],
  ['/benefits/details', 'benefits.detail'],
  ['/idcards/home', 'idcards.faxprint'],
  ['/idcards/request', 'idcards.request'],
  ['/claims/viewClaimDetails', 'claimsRedesign.detail'],
  ['/claims/listing/claims', 'claimsRedesign.listing'],
  ['/identityProtection/home1', 'identityProtection.home'],
  ['/identityProtection/home2', 'identityProtection.home2'],
  ['/bluerewards/home', 'bluerewards.home'],
  ['/bluerewards/home', 'bluerewards.memberDetails'],
  ['/bluerewards/home', 'bluerewards.rewardsPaid'],
  ['/bluerewards/home', 'bluerewards.hawefOnlineForm'],
  ['/bluerewards/home', 'bluerewards.changeRewardType'],
  ['/bluerewards/home', 'bluerewards.changePcp'],
  ['/bluerewards/home', 'bluerewards.learnmore'],
  ['/bluerewards/home', 'bluerewards.houseAccountResources'],
  ['/bluerewards/home', 'bluerewards.hawefResults'],
  ['/bluerewards/home', 'bluerewards.hawef'],
  ['/bluerewards/home', 'bluerewards.hawef.screeningoptions'],
  ['/bluerewards/home', 'bluerewards.hawef.onsitescreeninginstructions'],
  ['/bluerewards/home', 'bluerewards.hawef.cvsinstructions'],
  ['/bluerewards/home', 'bluerewards.hawef.actionplaninstructions'],
  ['/bluerewards/home', 'bluerewards.hawef.youractionplan'],
  ['/bluerewards/home', 'bluerewards.hawef.instructions'],
  ['/bluerewards/home', 'bluerewards.hawef.participantinfo'],
  ['/bluerewards/home', 'bluerewards.hawef.healthmeasures'],
  ['/bluerewards/home', 'bluerewards.hawef.screening'],
  ['/bluerewards/home', 'bluerewards.hawef.participantinfo'],
  ['/alertCenter', 'alertcenter.home'],
  ['/multipleAccounts', 'multipleAccount'],
  ['/drugs/cvsdrug/home', 'cvsdrug.home'],
  ['/messagecenter/home', 'messagecenter.home'],
  ['/messagecenter/view', 'messagecenter.fullmessage'],
  ['composeMessage', 'messagecenter.compose'],
  ['/claims', 'claimsRedesign.listing.claims'],
  ['/claims/listing/eob', 'claimsRedesign.listing.eob'],
  ['callCarefirst', 'contactUsCallCareFirst'],
  ['/claims/calendar', 'claimsRedesign.calendar'],
  ['/planadvisor', 'planadvisor.splashpage']
]);



// WEBPACK FOOTER //
// ./src/app/state-name-map.ts